
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { EventBus } from './eventBus.js';
import { Tariff } from "./TariffInterfaces";


@Component({
  name: "TariffCreate",
  props: {
    originManager: {
      default: false,
    },
    tariffId: {
      type: String,
      default: null,
    },
  },
})
export default class TariffCreate extends Vue {
  @Prop({ default: false }) readonly originManager!: boolean;
  @Prop({ default: null }) readonly client_id!: string | null;

  tariff: Tariff = {
    _id: null,
    vendor_id: null,
    client_id: null,
    currency: "INR",
    baseFare: null,
    version: null,
    axel: null,
    bodyType: null,
    truckType: null,
    country: "India",
    srcCity: null,
    dstCity: null
  };
  id: string | null = null;

  @Watch("tariffId", { immediate: true })
  onTariffIdChanged(newId: string, oldId: string) {
    if (newId !== oldId) {
      this.id = newId;
      this.detail();
    }
  }

  @Watch("client_id", { immediate: true })
  onClientIdChange(newId: string, oldId: string) {
    if (newId !== oldId) {
      const tariff: Tariff = this.tariffWithNullValues();
      this.tariff = {
        ...tariff,
        vendor_id: this.tariff.vendor_id,
        client_id: newId
      };
    }
  }
  tariffWithNullValues() {
    const tariff: Tariff = {
      client_id: null,
      _id: null,
      baseFare: null,
      currency: "INR",
      version: null,
      axel: null,
      vendor_id: null,
      bodyType: null,
      truckType: null,
      srcCity: null,
      dstCity: null,
      country: "India"
    }
    return tariff;
  }

  getDetailUrl(_id: string) {
    if (_id) {
      return `/api/tariff/${_id}/detail`;
    }
    return null;
  }

  get loading(): boolean {
    return common.loading;
  }


  setTariff(tariff: Tariff) {
    this.tariff = {
      ...this.tariff,
      _id: tariff._id || null,
      client_id: tariff.client_id || null,
      currency: tariff.currency || null,
      baseFare: tariff.baseFare || null,
      version: tariff.version || null,
      bodyType: tariff.bodyType || null,
      truckType: tariff.truckType || null,
      axel: tariff.axel || null,
      country : tariff.country|| null,
      srcCity : tariff.srcCity|| null,
      dstCity: tariff.dstCity || null
    };
  }

  async detail() {
    if (this.id) {
      const url = this.getDetailUrl(this.id);
      if (url) {
        common.setLoading(true);
        try {
          const response = await doGet(url);
          if (response) {
            this.setTariff(response);
          }
        } catch (error) {
          if (error instanceof Error) {
            common.setError(error.message);
          } else {
            common.setError('An error occurred.');
          }
        } finally {
          common.setLoading(false);
        }
      }
    }
  }

  async save() {
    common.setLoading(true);
    try {
      const response = await doPost("/api/tariff/save", this.tariff);
      if (response) {
        if (!this.id) {
          if (!this.originManager) {
            this.$router.push("/tariff/edit/" + response._id);
          }
        }
        EventBus.$emit("tariffSaved", true);
        this.detail();
      }
      common.showMessage("Saved Successfully");
    } catch (error) {
      if (error instanceof Error) {
        common.setError(error.message);
      } else {
        common.setError('An error occurred.');
      }
    } finally {
      common.setLoading(false);
    }
  }

  async saveAndSelect() {
    await this.save();
    this.$emit("change", this.tariff);
  }

  async mounted() {
    if (!this.originManager) {
      const id = this.$route.params.id;
      if (id) {
        this.id = id;
        await this.detail();
      }
    }
  }
}
